import { Component, OnInit } from '@angular/core';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AccountService } from 'src/app/services/account.service';
import { Subscription } from 'rxjs';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-upload-corporate-csv',
  templateUrl: './upload-corporate-csv.component.html',
  styleUrls: ['./upload-corporate-csv.component.css']
})
export class UploadCorporateCSVComponent implements OnInit {
  sectors: any = [];
  branches: any = [];
  subDomains: any = [];
  subDomain: any = '';
  corporates: any;
  corporate = 0;
  domain: any = 0;
  branch_importedDate = false;
  branchService_importedDate = false;
  branchdepart_importedDate = false;
  bspCorporate = 0;
  branchCorporate = 0;
  bdCorporate = 0;
  branch: any;
  branchCorporatefileToUpload: File;
  bspCorporatefileToUpload: File;
  bdCorporatefileToUpload: File;
  branchCorporate_loading$: boolean;
  bspCorporate_loading$: boolean;
  bdCorporate_loading$: boolean;
  bdDomainId = 0;
  bspDomainId = 0;
  branchDomainId = 0;
  bd_api_success: string;
  branch_corporate_api_success: string;
  bsp_api_success: string;
  bd_api_error: any;
  bsp_api_error: any;
  branch_corporate_api_error: any;
  fileUploadSubscription: Subscription;
  branchDomain: any = 0;
  uploadres: any;
  bspDomain: any = 0;
  bdDomain: any = 0;

  constructor(private commonService: CommonfilterService, private accountService: AccountService,
    private fileuploadService: FileUploadService, private router: Router, private activatedRoute: ActivatedRoute) { }


  ngOnInit() {
    this.FetchServiceSectors();
    // this.getCorporates();
  }

  FetchServiceSectors() {
    this.commonService.getServiceSectors().subscribe(
      (data) => {
        this.sectors = data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
        }


      });

  }
  // getCorporates() {
  //   this.accountService.getCorporates()
  //     .subscribe(data => {
  //       this.corporates = data;
  //     });
  // }

  onDomainChange(event) {
    this.subDomains = [];
    this.domain = '';
    this.subDomain = '';
    for (let i = 0; i < this.sectors.length; i++) {
      if (this.sectors[i].domain === event.target.value) {
        this.domain = this.sectors[i].domain;
        for (let j = 0; j < this.sectors[i].subDomains.length; j++) {
          this.subDomains.push({
            'displayName': this.sectors[i].subDomains[j].displayName,
            'id': this.sectors[i].subDomains[j].id, 'subDomain': this.sectors[i].subDomains[j].subDomain
          });
        }
      }
    }
  }


  /* --------------------   branch corporate section  starts here------------- */
  // branch domain change
  onbranchDomainChange(event) {
    this.subDomains = [];
    this.branchDomain = '';
    this.branchDomainId = 0;
    this.subDomain = '';
    for (let i = 0; i < this.sectors.length; i++) {
      if (this.sectors[i].domain === event.target.value) {
        this.branchDomain = this.sectors[i].domain;
        this.branchDomainId = this.sectors[i].id;
        for (let j = 0; j < this.sectors[i].subDomains.length; j++) {
          this.subDomains.push({
            'displayName': this.sectors[i].subDomains[j].displayName,
            'id': this.sectors[i].subDomains[j].id, 'subDomain': this.sectors[i].subDomains[j].subDomain
          });
        }
      }
    }
  }

  // branch corporate change
  onbranchCorporateChange(event) {
    this.branchCorporate = event.target.value;
  }


  // branch file upload selection
  handleBranchCorporateFileInput(branchcorporatefiles: FileList) {
    this.branchCorporatefileToUpload = branchcorporatefiles.item(0);
  }
  // branch corporate file upload
  uploadbranchCorporateFile() {
    this.branch_corporate_api_success = '';
    this.branch_corporate_api_error = '';
    this.branch = 0;
    if (this.isValidData(this.branchCorporatefileToUpload, this.branchCorporate, this.branchDomainId)) {
      this.branchCorporate_loading$ = true;
      this.fileUploadSubscription = this.fileuploadService
        .postbranchCorporateFile(this.branchCorporatefileToUpload, this.branchCorporate, this.branchDomainId, this.branch_importedDate)
        .subscribe(
          res => {
            this.uploadres = res;
            this.branchCorporate_loading$ = false;
            if (res === []) {
              this.branch_corporate_api_success = 'CSV uploaded successfully';
            } else {
              // this.displayResultInDialog(res);
              this.branch_corporate_api_success = res;
            }
          },
          error => {
            this.branchCorporate_loading$ = false;
            this.branch_corporate_api_error = error.error;
          }
        );

    } else {
      this.branch_corporate_api_error = 'Please select all required fields';
    }

  }

  /*--------- branch corporates ends here-----------*/

  /* ----------- branch Service Provider section start here-------------------   */
  // branch service provider  domain change

  onbspDomainChange(event) {
    this.subDomains = [];
    this.bspDomain = '';
    this.bspDomainId = 0;
    this.subDomain = '';
    for (let i = 0; i < this.sectors.length; i++) {
      if (this.sectors[i].domain === event.target.value) {
        this.bspDomain = this.sectors[i].domain;
        this.bspDomainId = this.sectors[i].id;
        for (let j = 0; j < this.sectors[i].subDomains.length; j++) {
          this.subDomains.push({
            'displayName': this.sectors[i].subDomains[j].displayName,
            'id': this.sectors[i].subDomains[j].id, 'subDomain': this.sectors[i].subDomains[j].subDomain
          });
        }
      }
    }
  }

  // branch service Provider corporate change
  onbspCorporateChange(event) {
    this.bspCorporate = event.target.value;
  }

  // branch file upload selection
  handleBspCorporateFileInput(bspcorporatefiles: FileList) {
    this.bspCorporatefileToUpload = bspcorporatefiles.item(0);
  }
  // branch corporate file upload
  uploadbspCorporateFile() {
    this.bsp_api_error = '';
    this.bsp_api_success = '';
    this.branch = 0;
    if (this.isValidData(this.bspCorporatefileToUpload, this.bspCorporate, this.bspDomainId)) {
    this.bspCorporate_loading$ = true;
    this.fileUploadSubscription = this.fileuploadService
      .postBspCorporateFile(this.bspCorporatefileToUpload, this.bspCorporate, this.bspDomainId, this.branchService_importedDate)
      .subscribe(
        res => {
          this.uploadres = res;
          this.bspCorporate_loading$ = false;
          if (res === []) {
            this.bsp_api_success = 'CSV uploaded successfully';
          } else {
            // this.displayResultInDialog(res);
            this.bsp_api_success = res;
          }
        },
        error => {
          this.branchCorporate_loading$ = false;
          this.bsp_api_error = error.error;
        }
      );
      } else {
        this.bsp_api_error = 'Please select all required fields';
      }
  }



  /*------branch service provider section ends here----------------->

  /*  branch Department section   */
  // branch department domain change
  onbdDomainChange(event) {
    this.subDomains = [];
    this.bdDomain = '';
    this.bdDomainId = 0;
    this.subDomain = '';
    for (let i = 0; i < this.sectors.length; i++) {
      if (this.sectors[i].domain === event.target.value) {
        this.bdDomain = this.sectors[i].domain;
        this.bdDomainId = this.sectors[i].id;
        for (let j = 0; j < this.sectors[i].subDomains.length; j++) {
          this.subDomains.push({
            'displayName': this.sectors[i].subDomains[j].displayName,
            'id': this.sectors[i].subDomains[j].id, 'subDomain': this.sectors[i].subDomains[j].subDomain
          });
        }
      }
    }
  }


  // branch department  corporate change
  onbdCorporateChange(event) {
    this.bdCorporate = event.target.value;
  }



  // branch file upload selection
  handleBdCorporateFileInput(bdcorporatefiles: FileList) {
    this.bdCorporatefileToUpload = bdcorporatefiles.item(0);
  }
  // branch corporate file upload
  uploadbdCorporateFile() {
    this.bd_api_success = '';
    this.bd_api_error = '';
    this.branch = 0;
    if (this.isValidData(this.bdCorporatefileToUpload, this.bdCorporate)) {
    this.bdCorporate_loading$ = true;
    this.fileUploadSubscription = this.fileuploadService
      .postBdCorporateFile(this.bdCorporatefileToUpload, this.bdCorporate, this.bdDomainId , this.branchdepart_importedDate)
      .subscribe(
        res => {
          this.uploadres = res;
          this.bdCorporate_loading$ = false;
          if (res === []) {
            this.bd_api_success = 'CSV uploaded successfully';
          } else {

            this.bd_api_success = res;
          }
        },
        error => {
          this.bdCorporate_loading$ = false;
          this.bd_api_error = error.error;
        }
      );
      } else {
        this.bd_api_error = 'Please select all required fields';
      }
  }
  goBacktoList() {
    this.router.navigate(['../list'], { relativeTo: this.activatedRoute });
  }

  isValidData(filetoUpload, section, subsection?) {
    if (filetoUpload === undefined || section === 0 || subsection === 0) {
      return false;
    } else {
      return true;
    }

  }

}
